//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {
      images: [
        "https://img.yzcdn.cn/vant/apple-1.jpg",
        "https://img.yzcdn.cn/vant/apple-2.jpg"
      ]
    };
  },
  created() {},

  methods: {}
};
